import AddCouponContainer from "./AddCouponContainer";
import AddCouponStore from "./AddCouponStore";

export default AddCouponStore(AddCouponContainer);